// ⚠️ NOTA: plansService temporariamente desabilitado
// Este serviço precisa de endpoints PHP específicos
// Use contentService para gerenciar conteúdo por enquanto

export const plansService = {
  async getAll(filters = {}) {
    console.warn('plansService.getAll não implementado ainda - use contentService');
    return [];
  },

  async getById(id) {
    console.warn('plansService.getById não implementado ainda');
    return null;
  },

  async create(planData) {
    throw new Error('Plans management via API not yet implemented');
  },

  async update(id, planData) {
    throw new Error('Plans management via API not yet implemented');
  },

  async delete(id) {
    throw new Error('Plans management via API not yet implemented');
  }
};
